import {Injectable} from '@angular/core';
import { Listing } from '../classes/listing';
import { HasSubscriptions } from '../components/has-subscriptions';
import { SaveSearchService } from './save-search.service';

@Injectable()
export class PostAuthenticationService extends HasSubscriptions {
  KEY_SAVE_SEARCH = "post-authentication_save-listing";

  constructor(private _saveSearchService: SaveSearchService)
  {
    super();
  }

  public storeSaveSearch(name: string, notification: boolean, listing: Listing){
  let saveSearch = {
    name: name,
    notification: notification,
    listing: listing
  }
  try{
      window.localStorage.setItem(this.KEY_SAVE_SEARCH, JSON.stringify(saveSearch));
    }
    catch(error){
      console.error(error)
    }
  }

  public processSaveSearch(){
    try{
      if(this.isSaveSearchReady()){
        let saveListingSearch = JSON.parse(window.localStorage.getItem(this.KEY_SAVE_SEARCH));
        this._saveSearchService.saveSearch(saveListingSearch.name, saveListingSearch.notification, saveListingSearch.listing);
        this.removeSaveSearch()
      }
    }
    catch(error){
      console.error(error)
    }
  }

  public isSaveSearchReady(){
    try{
      return window.localStorage.hasOwnProperty(this.KEY_SAVE_SEARCH);
    }
    catch(error){
      console.error(error)
    }
  }

  public removeSaveSearch(){
    try{
      window.localStorage.removeItem(this.KEY_SAVE_SEARCH);
    }
    catch(error){
      console.error(error)
    }
  }
}

